import { render, staticRenderFns } from "./NewPaymentsTable.vue?vue&type=template&id=5ce26716&scoped=true"
import script from "./NewPaymentsTable.vue?vue&type=script&lang=js"
export * from "./NewPaymentsTable.vue?vue&type=script&lang=js"
import style0 from "./NewPaymentsTable.vue?vue&type=style&index=0&id=5ce26716&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce26716",
  null
  
)

export default component.exports